import { HttpStatus } from 'app/utils/httpStatus';

export type ApiErrorType = 'not_found' | 'unavailable' | 'unknown';

export type ApiErrorShape = {
  response?: { status?: number; data?: { message?: unknown } };
  message?: unknown;
};

const MAX_ERROR_MESSAGE_LENGTH = 200;

export function truncateErrorMessage(message: string): string {
  return message.length > MAX_ERROR_MESSAGE_LENGTH
    ? `${message.slice(0, MAX_ERROR_MESSAGE_LENGTH)}…`
    : message;
}

function resolveApiErrorMessage(error: ApiErrorShape): string {
  const responseMessage = error?.response?.data?.message;

  if (typeof responseMessage === 'string' && responseMessage.trim() !== '') {
    return truncateErrorMessage(responseMessage);
  }

  return typeof error?.message === 'string' && error.message.trim() !== ''
    ? truncateErrorMessage(error.message)
    : 'unknown';
}

function resolveApiErrorType(status?: number): ApiErrorType {
  if (status === HttpStatus.NOT_FOUND) {
    return 'not_found';
  }

  if (status == null || status >= HttpStatus.INTERNAL_SERVER_ERROR) {
    return 'unavailable';
  }

  return 'unknown';
}

export function buildApiErrorProperties(error: unknown): {
  error_type: ApiErrorType;
  error_status: string;
  error_message: string;
} {
  const apiError = (error ?? {}) as ApiErrorShape;
  const status = apiError?.response?.status;

  return {
    error_type: resolveApiErrorType(status),
    error_status: typeof status === 'number' ? String(status) : 'unknown',
    error_message: resolveApiErrorMessage(apiError),
  };
}
